@if (!useSummaryView) {
  @if (!field.hidden) {
    <div animate.enter="fade-in" class="flex flex-col w-full">
      <div class="flex flex-row items-center w-full">
        @if (field.browserOpts.inLineWithCaption) {
          <mat-label class="mr-2 mb-4 font-medium">
            {{ field.label | localize }}
          </mat-label>
        }
        <mat-form-field class="w-full">
          @if (!field.browserOpts.inLineWithCaption) {
            <mat-label>
              {{ field.label | localize }}
            </mat-label>
          }
          <mat-icon matPrefix [svgIcon]="field.control.value"></mat-icon>
          <input matInput [readonly]="true" [formControl]="field.control" [required]="field.required" (click)="openDialog()" />
          @if (!field.required) {
            <button mat-icon-button matSuffix matTooltip="{{ 'deleteIcon' | transloco }}"
              (click)="deleteIcon()">
              <mat-icon svgIcon="mat_solid:close"></mat-icon>
            </button>
          }
          @if (field.hint) {
            <mat-hint>{{ field.hint | localize }}</mat-hint>
          }
          @if (!field.readonly &&
            field.control.touched &&
            field.control.hasError('required')) {
            <mat-error>
              {{ 'errorRequiredField' | transloco }}
            </mat-error>
          }
        </mat-form-field>
      </div>
    </div>
  }
} @else {
  <mat-icon [svgIcon]="field.control.value"></mat-icon>
  {{ field.control.value }}
}
